/** A refused or failed media action, in words the editor can act on. */

import type { Budget } from "@/api/admin";
import { ApiError } from "@/api/client";
import { bytes } from "@/lib/format";
import { plainFailure } from "./states";

export function explainMediaError(e: unknown, nameOf?: (type: string, id: string) => string | undefined): string {
  if (e instanceof ApiError) {
    if (e.code === "budget_exceeded") return `Not enough storage left: this needs ${bytes(Number(e.body["neededBytes"]))} and ${bytes(Number((e.body["budget"] as Budget).freeBytes))} is free. Delete videos you no longer use in Files.`;
    if (e.code === "uploads_not_configured") return "Uploads are not switched on for this brand yet. Ask ViewForm to switch them on.";
    if (e.code === "in_use") return `Still used by ${(e.body["by"] as Array<{ type: string; id: string }>).map((x) => `“${nameOf?.(x.type, x.id) ?? x.id}”`).join(", ")}. Remove it there first.`;
    return String(e.body["issue"] ?? e.code);
  }
  return plainFailure(e instanceof Error ? e.message : String(e));
}
